import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import WP from 'WP';

import css from 'css';

import CloseIcon from 'images/CloseIcon';
import Info from 'images/Info';
import Html from 'partials/Html';

import {
    setCheckoutVisibility,
    resetCheckout,
    resetCheckoutCustomer,
    resetCheckoutOpportunity,
} from 'store';

/**
 * CheckoutDisabled - Maintenance page displayed when checkout is disabled
 * 
 * Shows a user-friendly message explaining that checkout is temporarily unavailable
 * Provides contact information and a button to return to the site
 * Preserves all cart items when closed
 */

const Wrapper = styled.section`
    position: fixed;
    background: ${css.colors.main};
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow-y: auto;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
`

const Header = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 30px;

    @media(min-width: 768px) {
        padding: 30px 50px;
    }
`

const CloseButton = styled.button`
    cursor: pointer;
    color: #FFFFFF;
    background: none;
    border: none;
    padding: 0;
    
    &:hover {
        opacity: 0.8;
    }
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 600px;
    padding: 30px;
    text-align: center;
`

const IconWrapper = styled.div`
    margin-bottom: 30px;
    
    svg {
        width: 80px;
        height: 80px;
    }
`

const Title = styled.h1`
    color: #FFFFFF;
    font-size: 2em;
    line-height: 1.2em;
    margin-bottom: 20px;
    
    @media(min-width: 768px) {
        font-size: 2.5em;
    }
`

const Message = styled.p`
    color: #FFFFFF;
    font-size: 1.1em;
    line-height: 1.6em;
    margin-bottom: 20px;
    opacity: 0.9;

    h1, h2, h3, h4, h5, h6 {
        color: #FFFFFF;
        font-size: 2em;
        line-height: 1.2em;
        margin-bottom: 20px;
    }
`

const ContactInfo = styled.div`
    color: #FFFFFF;
    font-size: 1em;
    line-height: 1.8em;
    margin-top: 30px;
    padding: 20px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    
    strong {
        display: block;
        margin-bottom: 10px;
        font-size: 1.1em;
    }
    
    a {
        color: #FFFFFF;
        text-decoration: underline;
        
        &:hover {
            opacity: 0.8;
        }
    }
`

const ActionButton = styled.button`
    color: #FFFFFF;
    font-size: 18px;
    border: 2px solid #FFFFFF;
    background: transparent;
    padding: 15px 60px;
    margin-top: 30px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
`

class CheckoutDisabled extends Component {
    _closeCheckout() {
        // Reset checkout state when closing (preserves cart items)
        this.props.resetCheckout();
        this.props.resetCheckoutCustomer();
        this.props.resetCheckoutOpportunity();
        this.props.setCheckoutVisibility(false);
        // redirect to home page
        this.props.history.push('/');
    }

    render() {
        return (
            <Wrapper>
                <Header>
                    <CloseButton onClick={this._closeCheckout.bind(this)}>
                        <CloseIcon color="#FFFFFF" />
                    </CloseButton>
                </Header>

                <Content>
                    <IconWrapper>
                        <Info color="#FFFFFF" />
                    </IconWrapper>

                    <Message>
                        <Html content>{WP.options.bjorknes_checkout_message}</Html>
                    </Message>

                    <ActionButton onClick={this._closeCheckout.bind(this)}>
                        Tilbake til nettstedet
                    </ActionButton>
                </Content>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    checkout: state.checkout,
    message: WP.options.bjorknes_checkout_message || ''
});

const actions = {
    setCheckoutVisibility,
    resetCheckout,
    resetCheckoutCustomer,
    resetCheckoutOpportunity,
}

export default withRouter(connect(mapStateToProps, actions)(CheckoutDisabled));




// WEBPACK FOOTER //
// ./src/partials/Checkout/CheckoutDisabled.js